import { useSiteUtils } from '@voix/composables/useSiteUtils'

export default defineNuxtRouteMiddleware(async (to) => {
  const { getCurrentDomain } = useSiteUtils()
  const domain = getCurrentDomain()

  // console.log('[LOG] redirect middleware on', domain)

  if (domain === 'alltrabyplaya.com' || domain === 'alltra.playalogic.com') {
    console.log('[LOG] at alltrabyplaya checking', to.path)
    const pdcRedirectURL = 'https://www.wyndhamhotels.com/wyndham-alltra/playa-del-carmen-mexico/wyndham-alltra-playa-del-carmen-adults-only-all-inclusive/overview'
    const samanaRedirectURL = 'https://www.wyndhamhotels.com/wyndham-alltra/las-galeras-dominican-republic/wyndham-alltra-samana-all-inclusive-resort/overview'
    const puntaCanaRedirectURL = 'https://www.wyndhamhotels.com/wyndham-alltra/punta-cana-dominican-republic/wyndham-alltra-punta-cana-all-inclusive-resort/overview'

    if (to.path.includes('playa-del-carmen')) {
      console.log('[LOG] redirecting to:', pdcRedirectURL)
      return navigateTo(pdcRedirectURL, { external: true, redirectCode: 302 })
    }

    if (to.path.includes('samana')) {
      console.log('[LOG] redirecting to:', samanaRedirectURL)
      return navigateTo(samanaRedirectURL, { external: true, redirectCode: 302 })
    }

    if (to.path.includes('punta-cana')) {
      console.log('[LOG] redirecting to:', puntaCanaRedirectURL)
      return navigateTo(puntaCanaRedirectURL, { external: true, redirectCode: 302 })
    }

    return navigateTo('https://www.resortsbyhyatt.com', { external: true, redirectCode: 302 })
  }
})
